import { Button } from '../../../atoms/Button';
import { onFavoriteContent } from '../../../../../modules/Disciplines/queries/contentActions';
import { useEffect, useState } from 'react';
import { useContentActionsContext } from '../../../../hooks/Contexts/useContentActionsContext';

//"lesson", "exercise", "live", "practicetest", "communityquestion", "apostila", "audio", "mapamental"
export type IFavoriteCategory =
  | 'lesson'
  | 'exercise'
  | 'live'
  | 'practicetest'
  | 'communityquestion'
  | 'apostila'
  | 'audio'
  | 'mapamental';

interface IFavoriteButtonProps {
  onChange?: (isFavorite: boolean) => void;
  defaultFavorite?: boolean;
  category: IFavoriteCategory;
}

export function FavoriteButton({
  onChange,
  defaultFavorite,
  category,
}: IFavoriteButtonProps) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isFavorite, setIsFavorite] = useState<boolean>(
    defaultFavorite ?? false
  );

  const { contentId, contentType } = useContentActionsContext();

  async function handleFavorite() {
    if (!contentId || !contentType)
      return console.log('Content id or content type not found');

    const body = {
      category: category.replaceAll('_', ''),
      targetId: contentId,
      targetType: contentType,
    };

    setIsLoading(true);
    await onFavoriteContent(body);
    dispatchFavoriteContentEvent(!isFavorite);

    setIsFavorite(!isFavorite);
    setIsLoading(false);

    onChange && onChange(!isFavorite);
  }

  function dispatchFavoriteContentEvent(value: boolean) {
    const setContentFavorite = new CustomEvent('setContentFavorite', {
      detail: {
        contentId: contentId,
        favorite: value,
      },
    });
    window.dispatchEvent(setContentFavorite);
  }

  useEffect(() => {
    if (defaultFavorite !== undefined) setIsFavorite(defaultFavorite);
  }, [defaultFavorite]);

  return (
    <Button
      onClick={handleFavorite}
      onlyIcon
      variant='text'
      size='regular'
      LeftIcon={'star'}
      iconType='material'
      iconVariant='rounded'
      classNameIcon={`w-6 h-6 text-mono-color-medium filled ${
        isFavorite ? 'text-feedback-color-warning-pure' : ''
      }`}
      loading={isLoading}
      className={'p-0'}
    />
  );
}
